/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component} from 'react';
import { Route, Switch } from 'react-router';
import ReactDOM from 'react-dom'
// material
import {
    Button,
    SubPage,
    Copy,
    Title,
    SingleSelectDropDown,
    Content,
    Grid,
    GridSet,
    GridItem,
    Control,
    LoadState,
    EmptyState,
    PopupMessage
} from '@insticator/insticator-ui'; // iui-material
// utils
import { url } from 'utils/urls';
// pages
import Code from 'pages/dashboard/commenting/code/code';
import Configuration from 'pages/dashboard/commenting/configuration/configuration_container';
import AddOns from 'pages/dashboard/commenting/addons/addons';
import Statistics from 'pages/dashboard/commenting/statistics/statistics_container';
import Export from 'pages/dashboard/commenting/export/export';
import Advanced from 'pages/dashboard/commenting/advanced/advanced';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/commenting/commentmanager/commentmanager_styles';

const hideCommentingConfig = true

/* ========== ~~~~~~~~~~ COMMENT MANAGER ~~~~~~~~~~ ========== */
class CommentManager extends Component {
    constructor(props){
        super(props);
        this.state = {
            selectedTab: 'code',
            selectedSite: null
        };
        this.iframeEl = null;
    }

    componentDidMount() {
        // set first site as selected
        if(Object.keys(this.props.sites).length) {
            const siteUUID = this.props.mockupGenerator ? this.props.siteUUID : Object.keys(this.props.sites)[0];
            const siteName = this.props.sites[siteUUID];
            this.props.selectCommentSite({
                value: siteUUID,
                name: siteName
            });
            this.props.getConfiguration(this.props.accountUUID, siteUUID, siteName, this.getCommentingUnitCode);
        }
        this.props.moveToPage(`dashboard/commenting/commentmanager/${this.state.selectedTab}`)
    }

    componentDidUpdate(prevProps) {
        if(Object.keys(this.props.sites).length !== Object.keys(prevProps.sites).length){
            const site = {value: Object.keys(this.props.sites)[0], name: this.props.sites[Object.keys(this.props.sites)[0]]}
            this.props.selectCommentSite(site);
            this.props.getConfiguration(this.props.accountUUID, site.value, site.name, this.getCommentingUnitCode);
        }
    };

    handleSiteInDropDown = () => {
        let sites = [];
        Object.keys(this.props.sites).forEach( (item) => {
            sites.push({value: item, name: this.props.sites[item]})
        });
        return sites
    };

    selectSite = site => {
        const { accountUUID } = this.props;
        this.props.selectCommentSite(site);
        this.props.getConfiguration(accountUUID, site.value, site.name, this.getCommentingUnitCode);
    }

    handleTabSelect = selectedTab => {
        this.setState({ selectedTab }, this.props.moveToPage(`dashboard/commenting/commentmanager/${selectedTab}`));
        if (selectedTab === 'code') this.getCommentingUnitCode();
    }

    getCommentingUnitCode = () => {
        this.props.getCommentingUnitCode(this.props.selectedSite.value);
    }

    /*previewTestPage = () => {
        this.props.displayModal(true, <PopupMessage
            type={'preview'}
            title={'Would you like to navigate to the commenting test page?'}
            body={<p><br/></p>}
            buttonPrimary={{ text: 'Preview', variant: 'primary', action: () => window.open(`${url.ccu.commentingUnits}/${this.props.commentingUnitUUID}/test-page/pageTitle3`)  && this.props.displayModal(false)}}
            buttonSecondary={{ text: 'Cancel', variant: 'system', action: () => this.props.displayModal(false) }}
        />);
    }*/

    redirectToUsersV2 = () => window.open(`https://publisher-portal.${url.baseURL}/dashboard/commenting/code`, '_self')

    render(){
        return (
            <Content>
                <SubPage name={`commentmanager`} klass={this.props.classes.commentmanager}>
                    { !hideCommentingConfig ?
                    <>
                    <Copy name={`page-copy`}>
                        <Title variant={`withtip`}>
                            <h2>Commenting {this.props.selectedSite ? `(${this.props.selectedSite.name})` : null}</h2>
                            {/*<Tip space={`left`} content={<p>An ads.txt file is a simple text file (not an Embed code) that is uploaded into your domain’s root directory. In other words, it is implemented the same way a robots.txt file on your root domain would be implemented.</p>}/>*/}
                        </Title>
                    </Copy>
                    <Grid>
                        <GridSet direction={`horizontal`} name={`commentingcontrols`}>
                            <GridItem direction={`horizontal`} name={'controls_test_page'}>
                                <div className={`controls`}>
                                    <Control selected={this.state.selectedTab === 'code'} text={`Code`} value={`code`} handleSelect={this.handleTabSelect} />
                                    <Control selected={this.state.selectedTab === 'configuration'} text={`Configuration`} value={`configuration`} handleSelect={this.handleTabSelect} />
                                    <Control selected={this.state.selectedTab === 'addons'} text={`Add-ons`} value={`addons`} handleSelect={this.handleTabSelect} />
                                    <Control selected={this.state.selectedTab === 'statistics'} text={`Statistics`} value={`statistics`} handleSelect={this.handleTabSelect} />
                                    <Control selected={this.state.selectedTab === 'export'} text={`Export`} value={`export`} handleSelect={this.handleTabSelect} />
                                    {this.props.mocked && <Control selected={this.state.selectedTab === 'advanced'} text={`Advanced`} value={`advanced`} handleSelect={this.handleTabSelect} />}
                                </div>
                                {this.props.mocked && <Button variant={'secondary'} text={'Test Page'} action={`${url.ccu.commentingUnits}/${this.props.commentingUnitUUID}/test-page/pageTitle3`} type={'external'} />}
                            </GridItem>
                            <GridItem name={'sites'}>
                                <span className={'fieldlabel'}>Website: </span>
                                <SingleSelectDropDown onSelect={this.selectSite} disabled={false} selected={this.props.selectedSite} name={`all sites`} items={this.handleSiteInDropDown()}/>
                            </GridItem>
                        </GridSet>
                    </Grid>
                  
                    {this.props.fetchingConfigs ? <LoadState/> :
                        (<Switch>
                            <Route exact path='/dashboard/commenting/commentmanager/configuration' component={Configuration} />
                            <Route exact path='/dashboard/commenting/commentmanager/addons' component={AddOns} />
                            <Route exact path='/dashboard/commenting/commentmanager/statistics' component={Statistics} />
                            <Route exact path='/dashboard/commenting/commentmanager/export' component={Export} />
                            <Route exact path='/dashboard/commenting/commentmanager/advanced' component={Advanced} />
                            <Route path='/dashboard/commenting/commentmanager' component={Code} />
                        </Switch>)
                    }
                    </>
                    :
                    <EmptyState 
                        graphicName={'error-404'} 
                        buttonText={'Go to Commenting Configuration'} 
                        bodycopy={<p>Commenting Configuration has been moved to <b>Publisher Portal V2 (Beta)</b></p>} 
                        buttonClick={() => this.redirectToUsersV2()} 
                        buttonName={'gotoppv2users'}
                    />
                    }
                </SubPage>
            </Content>
        );
    }

};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(CommentManager);
